<template>
  <v-layout row>
    <v-flex xs12 sm12 offset-sm>
      <v-card>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="text-xs-center">
            LOAN ACCOUNTS
          </v-toolbar-title>            
            
          <v-spacer></v-spacer>  
          
          <v-card-actions class="justify-center">
            <v-btn 
              @click="getFirms"
              class="primary white--text">
              ADD NEW LOAN ACCOUNT
            </v-btn>
          </v-card-actions>
        </v-toolbar>  
      <v-card> 
        <template v-for="(item, index) in getLoanAccount">
          <v-divider :key="item['.key']"></v-divider>
            <v-card :key="index">
              <v-card-title>
                <v-card-text> 
                  Firm :- <b>{{firmbyId(item.firm)}}</b> &nbsp; &nbsp; &nbsp;  
                  Account Holder Name :- <b>{{item.accountHolderName}}</b> &nbsp; &nbsp; &nbsp;
                  <!-- Opening Balance :- <b>&#8377;{{item.openingBalance}}</b>&nbsp; &nbsp; &nbsp; -->
                  Opening Balance :- <b>&#8377;{{item.amount}} </b>
                </v-card-text>
                <v-card-text>
                  Account Number :- <b>{{item.accountnumber}}</b> &nbsp; &nbsp; &nbsp;
                  Loan Category :- <b>{{item.loanCategory}}</b> &nbsp; &nbsp; &nbsp;
                </v-card-text>
                  <!-- Bank Name :- <b>{{item.bankName}}</b> &nbsp; &nbsp; &nbsp;  
                  Account Type :- <b>{{item.accountType}}</b></v-card-text> -->
                  <!-- <v-card-text> Account Holder Name :- <b>{{item.accountHolderName}}</b></v-card-text> -->
                  <!-- <v-card-text> Account Number :- <b>{{item.accountnumber}}</b> &nbsp; &nbsp; &nbsp; Account Type :- <b>{{item.accountType}}</b></v-card-text> -->
                  <!-- <v-card-text>  
                    IFSC Code :- <b>{{item.ifsccode}}</b> &nbsp; &nbsp; &nbsp; 
                    Location :- <b>{{item.accountLocation}}</b> &nbsp; &nbsp; &nbsp; 
                  </v-card-text> -->
                  <!-- <v-card-text> Available Balance :- <b>{{item.amount}}</b> &nbsp; &nbsp; &nbsp; Firm :- <b>{{firmbyId(item.firm)}}</b></v-card-text> -->
                  <!-- <v-card-text> Firm :- <b>{{firmbyId(item.firm)}}</b></v-card-text> -->
                </v-card-title>
                <v-card-actions>
                  <v-btn flat icon class="primary white--text" @click="editLoanAccount(item['.key'])">
                    <v-icon color="grey white--text">edit</v-icon>
                  </v-btn>  
                  <v-btn flat icon class="primary white--text" @click="deleteLoanAccount(item['.key'])">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-card>
        </v-card>
    </v-flex>
    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title primary title class="primary white--text">
           <span class="headline">Add New Loan Account</span> 
        </v-card-title>
        <v-card-text>
          <v-select
          item-text="name"
          item-value="id"
          :items="items"
          v-model="currentFirm"
          label="Select Firms"
        ></v-select>
          <!-- <v-select
          item-text="name"
          item-value="id"
          :items="currentBankName"
          v-model="bankName"
          label="Choose Bank"
        ></v-select> -->
        <v-select
          item-text="name"
          item-value="id"
          :items="currentLoanCategory"
          v-model="loanCategory"
          label="Choose Loan category"
        ></v-select>
        <!-- <v-select
          item-text="name"
          item-value="id"
          :items="currentAccountType"
          v-model="accountType"
          label="Choose Account Type"
        ></v-select> -->
          <v-text-field label="Account Holder Name" v-model="accountHolderName" ></v-text-field>
          <v-text-field label="Account Number" v-model="accountnumber" ></v-text-field>
          <v-text-field label="Amount" v-model="initialamount" ></v-text-field>
          <!-- <v-text-field label="Opening Balance" v-model="openingBalance" ></v-text-field> -->
          <!-- <v-text-field label="IFSC code" v-model="ifsccode" ></v-text-field>
          <v-text-field label="Location" v-model="accountLocation" ></v-text-field> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn primary title class="primary white--text" flat="flat" @click="cancelDialog">
            Cancel
          </v-btn>
          <v-btn primary title class="success white--text" flat="flat" @click="addNewLoanAccount">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import { debug, debuglog } from 'util';

const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
export default {
  name: 'Loan',
  data () {
    return {
      dialog: false,
      items:null,
      // bankName:null,
      // accountType:null,
      loanCategory:null,
      currentFirm:{
        id:'',
        name:''
      },
      currentLoanCategory: [
        'Secure Loan',
        'Unsecure Loan',        
      ],
    //   currentBankName:[
    //     'Allahabad Bank',
    //     'Andhra Bank',
    //     'Axis Bank',
    //     'Bandhan Bank',
    //     'Bank of India',
    //     'Bank Of Baroda',
    //     'Bank Of Maharastra',
    //     'Canara Bank',
    //     'Central Bank Of India',
    //     'Corporation Bank',
    //     'Dena Bank',
    //     'DCB bank',
    //     'HDFC bank',
    //     'ICICI Bank',
    //     'Indian Overseas Bank',
    //     'Kotak Mahindra Bank',
    //     'Oriental Bank Of Commerce',
    //     'Punjab National Bank',
    //     'Punjab and Sind Bank',
    //     'State Bank Of India',
    //     'UCO Bank',
    //     'Union Bank Of India',
    //     'Vijaya Bank',
    //     'Yes Bank',
    //   ],
    //   currentAccountType:[
    //     'S/A',
    //     'C/A',
    //     'O/D'
    //   ],
    //   ifsccode:null,
    //   accountLocation:null,
      accountHolderName: null,
      accountnumber:0,
      firms: [],
      openingBalance:0,
      initialamount:0
    }
  },
  created () {
    this.$bindAsArray(
      'firms',
      this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'account',
      this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'loan',
      this.$root.$firebaseRefs.loan.orderByChild('brand').equalTo(this.selectedBrand)
    )
  },
  computed: {
    ...mapGlobalGetters(['selectedBrand']),
    getLoanAccount () {
      if (this.selectedBrand) {
        return this.loan.filter(item => item['brand'] === this.selectedBrand)
      }
    },
    loanCount () {
      return this.getLoanAccount.length || 0
    }  
  },
  methods: {
    firmbyId(id){
      return this.firms.filter(item => item['.key'] == id)[0].name
    },
    addNewLoanAccount () {
        let data ={
          brand:this.selectedBrand,
          firm:this.currentFirm,
          accountHolderName:this.accountHolderName,
          // openingBalance:Number(this.openingBalance),
          amount: Number(this.initialamount),
          loanCategory:this.loanCategory,
          accountnumber:this.accountnumber,
          //   bankName:this.bankName,
          //   ifsccode:this.ifsccode,
          //   accountLocation:this.accountLocation,
          //   accountType:this.accountType,
        }
        this.$root.$firebaseRefs.loan.push(data);
        // this.addInvoice();
        this.dialog=false;
        this.currentFirm="";
        this.accountHolderName=null;
        // this.openingBalance=0;
        this.amount=0;
        this.accountnumber=0;
        this.loanCategory="";
        // this.bankName="";
        // this.ifsccode=null;
        // this.accountType="";
        // this.accountLocation=null;
    },
    addInvoice(){
      let invoiceData = {
          brand: this.selectedBrand,
          type:'automatic invoice',
          firm:this.currentFirm,
          paymentType:'bank',
          accountNumber:this.accountnumber,
          accountHolderName:this.accountHolderName,
          // openingBalance:Number(this.openingBalance),
          isCredited:true,
          totalAmount:Number(this.initialamount),
          date:Date.now()
      }
      this.$root.$firebaseRefs.invoice.push(invoiceData);
    },
    deleteLoanAccount(key){
      confirm('Are you sure you want to delete this Bank Account') &&
      this.$root.$firebaseRefs.loan.child(key).remove();
    },
    cancelDialog(){
      this.dialog = false;
    },
    getFirms () {
        this.dialog =true;
        let firms = this.firms.filter(item => item['brand'] === this.selectedBrand)
        var totalitem = [];
        firms.forEach(function (arrayItem) {
            totalitem.push({
                id :arrayItem['.key'],
                name: arrayItem.name
            })
        })
        this.items = totalitem;
    },
    getLoanAccount () {
      this.dialog =true;
        let loan = this.loan.filter(item => item['brand'] === this.selectedBrand)
        var totalitem = [];
        loan.forEach(function (arrayItem) {
            totalitem.push({
                id :arrayItem['.key'],
                name: arrayItem.name
            })
        })
        this.items = totalitem;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Settings/Loan/index.vue